<div class="col-md-12">
  <div class="row mb-3">
    <div class="col-md-8">
      <span class="badge badge-primary">{{ lignesBudget?.length || 0 }} ligne(s) de budget</span>
    </div>
    <div class="col-md-4 text-right">
      <button class="btn btn-primary btn-sm" (click)="addLigneBudget()">
        <i class="feather icon-plus"></i> Ajouter
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
      <thead class="thead-light">
        <tr>
          <th>Code</th>
          <th>Libellé</th>
          <th>Type</th>
          <th>Compte OHADA</th>
          <th>Catégorie</th>
          <th>Montant prévu</th>
          <th>Montant réalisé</th>
          <th>Écart</th>
          <th>Récup.</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of lignesBudget">
          <td>{{ item?.code }}</td>
          <td>{{ item?.libelle }}</td>
          <td>
            <span class="badge" [ngClass]="item?.type === 'DEPENSE' ? 'badge-danger' : 'badge-success'">
              {{ item?.type }}
            </span>
          </td>
          <td>{{ item?.compteOHADA }}</td>
          <td>{{ item?.categorie }}</td>
          <td class="text-right">{{ item?.montant | number:'1.0-0' }} FCFA</td>
          <td class="text-right">{{ item?.montantRealise | number:'1.0-0' }} FCFA</td>
          <td class="text-right" [ngClass]="item?.ecart >= 0 ? 'text-success' : 'text-danger'">
            {{ item?.ecart | number:'1.0-0' }} FCFA
          </td>
          <td class="text-center">
            <span class="badge" [ngClass]="item?.estRecuperable ? 'badge-success' : 'badge-secondary'">
              {{ item?.estRecuperable ? 'Oui' : 'Non' }}
            </span>
          </td>
          <td class="text-center">
            <button class="btn btn-icon btn-outline-primary btn-sm mr-1" title="Modifier" (click)="editLigneBudget(item)">
              <i class="feather icon-edit-2"></i>
            </button>
            <button *ngIf="item?.isDelete" class="btn btn-icon btn-outline-danger btn-sm" title="Supprimer" (click)="deleteLigneBudget(item)">
              <i class="feather icon-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
